"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildImageUrl = buildImageUrl;
// Crop around the image's stored Amplience point-of-interest metadata instead of
// the centre. Appended raw (not via searchParams) so the `{`/`}`/`$` binding
// tokens stay unencoded for Amplience to resolve at delivery time.
const POI_TRANSFORM = "scaleFit=poi&poi=" +
    "{$this.metadata.pointOfInterest.x}," +
    "{$this.metadata.pointOfInterest.y}," +
    "{$this.metadata.pointOfInterest.w}," +
    "{$this.metadata.pointOfInterest.h}";
function buildImageUrl(rawUrl, params, { applyPoi = false } = {}) {
    // Console preview templates pass Mustache tokens (e.g. "{{ctImage}}") in place
    // of image URLs. These are not valid URLs, so pass them through untouched
    // instead of throwing. Real image URLs never contain "{{".
    if (rawUrl.includes("{{"))
        return rawUrl;
    const url = new URL(rawUrl.trim());
    url.search = "";
    Object.entries(params).forEach(([key, value]) => {
        url.searchParams.set(key, value);
    });
    const result = url.toString();
    return applyPoi ? `${result}&${POI_TRANSFORM}` : result;
}
